import React from "react";
import { cn } from "../../Utils/helper";

const SystemMaintenance = () => {
  return (
    <div className="flex justify-center px-7 flex-col  items-center gap-6 h-screen w-full">
      <h4
        className={cn(
          "text-[#253FF6]  text-center   font-[Figtree]   text-2xl  font-bold   not-italic     leading-normal "
        )}
      >
        System maintenance, <br /> please come back soon!
      </h4>
      <div className="flex flex-row gap-1">
        <p
          className="text-[#A0A0A0] 
         text-center 
         font-[Figtree] 
         text-sm 
         font-medium 
         not-italic 
         leading-[21px]"
        >
          For any issues, please
        </p>

        <a
          className=" text-[#253FF6] 
         font-[Figtree] 
         text-sm
         font-bold 
         not-italic 
         leading-normal"
          href="mailto:hello@letsrally.ai"
        >
          contact us.
        </a>
      </div>
    </div>
  );
};

export default SystemMaintenance;
